export default __webpack_public_path__ + "static/media/new3.23500a25.jpg";